import { useCallback } from 'react';
import { toast } from 'sonner';
import { useMode } from '@/providers/ModeProvider';

/**
 * Mode-aware export handler seam.
 *
 * Keeps components from branching on `isDemo`: in demo mode it runs the
 * client-side export, in live mode it triggers the server-side export and
 * notifies the user that the file is being prepared.
 */
export function useModeAwareExport(demoExport: () => void, liveExport: () => void): () => void {
  const { isDemo } = useMode();

  return useCallback(() => {
    if (isDemo) {
      demoExport();
    } else {
      liveExport();
      toast.info('Export started. You will be notified when the file is ready.');
    }
  }, [isDemo, demoExport, liveExport]);
}
